import { action } from 'typesafe-actions';
import { 
  STORE_RESULT_LIDZOEKEN, 
  CLEAR_LIDZOEKEN, 
  START_LIDZOEKEN, 
  STOP_LIDZOEKEN, 
  SET_CONSENT_LIDZOEKEN,
  PASSTHROUGH_FIELD_LIDZOEKEN
 } from '../constants/Constants';

export const storeLidZoeken = (
    results : any[],
    lidnummer: string, 
    postcode: string, 
    huisnummer: string, 
    geboortedatum: string,
    zoekenOp: string,
    searchValue: string,
    formName: string,
    additionalData : any) => action(STORE_RESULT_LIDZOEKEN, 
  {
    results : results,
    lidnummer: lidnummer,
    postcode: postcode,
    huisnummer: huisnummer,
    geboortedatum: geboortedatum,
    zoekenOp: zoekenOp,
    searchValue: searchValue,
    formName: formName,
    additionalData : additionalData
  });

export const clearLidZoeken = () => action(CLEAR_LIDZOEKEN);
export const startLidZoeken = () => action(START_LIDZOEKEN);
export const stopLidZoeken = () => action(STOP_LIDZOEKEN);
export const setConsentLidZoeken = (id : string, consent: boolean) => action(SET_CONSENT_LIDZOEKEN, {
  id: id,
  consent: consent
});
export const passthroughLidZoeken = (fieldName : string, value : any) => action(PASSTHROUGH_FIELD_LIDZOEKEN, {
  fieldName : fieldName,
  value : value
});
